import { useCallback, useState } from "react";
import { useApi } from "../apiCall/useApi";
import Joi from "joi";
import { Urls } from "../../../utils/constant";
import { size } from "lodash";
import { useSnackbar } from "notistack";

import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { useDispatch } from "react-redux";

import Api from "../../../utils/api.utils";

export const labReportEntrySchema = Joi.object({
  reportName: Joi.string().required().messages({
    "string.empty": "Report Name is required.",
  }),
  remark: Joi.string().optional().allow(""),
});

export function useLabReportForm({ existingImageUrl, labtestId }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [Image, setImage] = useState(existingImageUrl);

  const labTestReportEntry = useCallback(
    async ({ remark, reportName }) => {
      const image_url = [];

      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());

        if (size(Image?.name) > 0) {
          const form = new FormData();
          form.append("file", Image);

          const image_response = await Api.post2(
            {
              url: Urls.imageAdd(),
              data: form,
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
              },
            },
            []
          );

          image_url.push(image_response?.data[0]);
        }
        const { data } = await apiPost({
          url: Urls.labtestReportAdd(),
          data: {
            appointment_lab_test_id: labtestId,
            report_url: image_url[0]?.url,
            remark: remark,
            report_name: reportName,
            status: 1,
            insert_by: null,
          },

          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (size(data.id) === 36) {
          enqueueSnackbar("Lab Test Report Data Added Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [loading, Image, labtestId]
  );

  const labTestReportUpdate = useCallback(
    async ({ id, remark, reportName }) => {
      if (loading) return;
      setLoading(true);

      const image_url = [];

      try {
        dispatch(showPageLoader());

        if (size(Image?.name) > 0) {
          const form = new FormData();
          form.append("file", Image);

          const image_response = await Api.post2(
            {
              url: Urls.imageAdd(),
              data: form,
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
              },
            },
            []
          );

          image_url.push(image_response?.data[0]);
        }
        const { data } = await apiPost({
          url: Urls.labTestUpdate(),
          data: {
            id: id,
            appointment_lab_test_id: labtestId,
            report_url:
              size(image_url[0]?.url) > 0
                ? image_url[0]?.url
                : Image?.url || existingImageUrl,
            remark: remark,
            report_name: reportName,
            status: 1,
            update_by: null,
          },

          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (size(data.id) === 36) {
          enqueueSnackbar("Lab Report Data Updated Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [loading, Image, labtestId]
  );

  const handleFileChange = useCallback((img) => {
    setImage(img);
  }, []);

  return {
    labTestReportEntry,
    labTestReportUpdate,
    handleFileChange,
    labReportEntrySchema,
  };
}
